import { createFileRoute } from '@tanstack/react-router';
import { ReferrerDashboard } from '@/pages/referrer/dashboard';

export const Route = createFileRoute('/referrer/_layout/dashboard')({
  component: ReferrerDashboard,
});
